import React, { useCallback, useContext, type MouseEventHandler } from 'react'
import ModalContext from 'contexts/ModalContext'
import IconButton from 'LuxKit/Button/IconButton'
import LineExclamationTriangleIcon from 'LuxKit/Icons/line/LineExclamationTriangleIcon'
import BusinessTravellerPolicyDebugModal, {
  type PolicyDebugSource,
  type PolicyDebugSurface,
  type PolicyDebugVertical,
} from './BusinessTravellerPolicyDebugModal'
import { isProduction } from 'lib/env/isProduction'

interface Props {
  source: PolicyDebugSource
  vertical: PolicyDebugVertical
  surface: PolicyDebugSurface
  primaryData: unknown
  comparisonData?: unknown
  cacheKey?: string
  employeeIds?: Array<string>
}

export default function BusinessTravellerPolicyDebugButton(props: Props) {
  const showModal = useContext(ModalContext)

  const openDebugModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<BusinessTravellerPolicyDebugModal {...props} />)
  }, [props, showModal])

  if (isProduction()) {
    return null
  }

  return (
    <IconButton
      kind="tertiary"
      size="small"
      onClick={openDebugModal}
      aria-label="Item policy debug"
    >
      <LineExclamationTriangleIcon />
    </IconButton>
  )
}
